import { render, staticRenderFns } from "./ProfileDrawer.vue?vue&type=template&id=7bb9c020&scoped=true&"
import script from "./ProfileDrawer.vue?vue&type=script&lang=js&"
export * from "./ProfileDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDrawer.vue?vue&type=style&index=0&id=7bb9c020&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb9c020",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VNavigationDrawer})
